import React from "react";

type Props = {
  text: string;
};

export const NewlineDisplay: React.FC<Props> = ({ text }: Props) => {
  return <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{text}</div>;
};
